@if (invitertTil().length > 0) {
<div class="ramme">

<span class="overskrift">{{ 'Dine invitasjoner'|translate }}</span>

  <table mat-table matSort [dataSource]="invitertTilDataSource">

    <ng-container matColumnDef="gruppeOrganisasjonsnavn">
      <th *matHeaderCellDef mat-header-cell mat-sort-header > {{ 'Organisasjon'|translate }}</th>
      <td mat-cell *matCellDef="let invitasjon"> {{ invitasjon.gruppeOrganisasjonsnavn }}</td>
    </ng-container>
    <ng-container matColumnDef="gruppeTittel">
      <th mat-header-cell mat-sort-header *matHeaderCellDef > {{ 'Gruppe'|translate }}</th>
      <td mat-cell *matCellDef="let invitasjon"> {{ invitasjon.gruppeTittel }}</td>
    </ng-container>
    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef> {{ 'Rolle'|translate }}</th>
      <td mat-cell *matCellDef="let invitasjon"> {{ invitasjon.rolle?.tittel }}</td>
    </ng-container>
    <ng-container matColumnDef="opprettetDato">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Invitert dato'|translate }}</th>
      <td mat-cell *matCellDef="let invitasjon"> {{ invitasjon.opprettetDato |zoneddatetimeSomPlaindate|plaindate}}</td>
    </ng-container>

    <ng-container matColumnDef="vis">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let invitasjon" class="handlinger">
        <button mat-button type="button" color="primary" (click)="godta(invitasjon)" data-testid="godta">
          <mat-icon fontSet="ion-ios-checkmark-empty" class="mat-icon--ionic-ikon"/>
          {{ "Godta"|translate }}
        </button>
        <button mat-button type="button" color="warn" (click)="avslaa(invitasjon)" data-testid="avslå">
          <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
          {{ "Avslå"|translate }}
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['gruppeOrganisasjonsnavn', 'gruppeTittel','role','opprettetDato','vis']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['gruppeOrganisasjonsnavn', 'gruppeTittel','role','opprettetDato','vis'];"></tr>

  </table>
</div>
} @else {
  <!--  viser ingenting-->
}
